export default function () {
  window.document.addEventListener('DOMContentLoaded', () => {
    const destinationComponents = window.document.querySelectorAll('.js-destination');

    destinationComponents.forEach((destinationComponent) => {
      const search = destinationComponent.querySelector('.js-catalog-search');
      const catalogWrapper = destinationComponent.querySelector('.js-catalog-wrapper');
      const clean = destinationComponent.querySelector('.js-destination-clean');
      const empty = destinationComponent.querySelector('.js-catalog-wrapper-empty');

      if (!search || !catalogWrapper) {
        return;
      }

      const properties = catalogWrapper.querySelectorAll('.js-destination-property');
      const locations = catalogWrapper.querySelectorAll('.js-destination-location');

      const locationLevels = new Map();
      const locationChildren = new Map();

      function getLocationLevel(locationElement) {
        const classList = locationElement.className;
        const levelMatch = classList.match(/c-destination__location--level-(\d+)/);
        return levelMatch ? parseInt(levelMatch[1], 10) : 0;
      }

      function getLocationChildren(locationElement) {
        const children = [];
        const currentLevel = locationLevels.get(locationElement);

        if (currentLevel === undefined) {
          const level = getLocationLevel(locationElement);
          locationLevels.set(locationElement, level);
          return getLocationChildren(locationElement);
        }

        let nextSibling = locationElement.nextElementSibling;

        while (nextSibling) {
          if (nextSibling.classList.contains('js-destination-location')) {
            const nextLevel = locationLevels.get(nextSibling);
            if (nextLevel <= currentLevel) {
              break;
            }
          }
          children.push(nextSibling);
          nextSibling = nextSibling.nextElementSibling;
        }

        return children;
      }

      locations.forEach((location) => {
        const level = getLocationLevel(location);
        locationLevels.set(location, level);
      });

      locations.forEach((location) => {
        locationChildren.set(location, getLocationChildren(location));
      });

      function showAllElements() {
        [...properties, ...locations].forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.style.display = '';
        });
      }

      function hideAllElements() {
        [...properties, ...locations].forEach((element) => {
          // eslint-disable-next-line no-param-reassign
          element.style.display = 'none';
        });
      }

      function textMatches(element, searchTerm) {
        if (element.classList.contains('js-destination-property')) {
          const title = element.querySelector('.js-destination-title');
          return title?.textContent.trim().toLowerCase().includes(searchTerm);
        }
        return element.textContent.trim().toLowerCase().includes(searchTerm);
      }

      function getParentLocation(element) {
        let current = element.previousElementSibling;
        const elementLevel = element.classList.contains('js-destination-location')
          ? locationLevels.get(element)
          : 3;

        while (current) {
          if (current.classList.contains('js-destination-location')) {
            const currentLevel = locationLevels.get(current);
            if (currentLevel < elementLevel) {
              return current;
            }
          }
          current = current.previousElementSibling;
        }

        return null;
      }

      function showChildren(children) {
        children.forEach((child) => {
          // eslint-disable-next-line no-param-reassign
          child.style.display = '';
        });
      }

      function showLocationWithParents(location, level) {
        if (level === 2) {
          const parentLocation = getParentLocation(location);
          if (parentLocation) {
            parentLocation.style.display = '';
          }
        }
        // eslint-disable-next-line no-param-reassign
        location.style.display = '';
      }

      function filterLocations(searchTerm) {
        locations.forEach((location) => {
          const level = locationLevels.get(location);
          const children = locationChildren.get(location);

          if (textMatches(location, searchTerm)) {
            showLocationWithParents(location, level);
            showChildren(children);
          }
        });
      }

      function showPropertyWithParents(property) {
        const parentCountry = getParentLocation(property);
        if (parentCountry) {
          const parentContinent = getParentLocation(parentCountry);
          if (parentContinent) {
            parentContinent.style.display = '';
          }
          parentCountry.style.display = '';
        }
        // eslint-disable-next-line no-param-reassign
        property.style.display = '';
      }

      function filterProperties(searchTerm) {
        properties.forEach((property) => {
          if (textMatches(property, searchTerm)) {
            showPropertyWithParents(property);
          }
        });
      }

      function updateEmptyState() {
        requestAnimationFrame(() => {
          const hasVisibleContent = catalogWrapper.offsetHeight > 0;
          empty.classList.toggle('show', !hasVisibleContent);
        });
      }

      function filterDestinations(searchTerm) {
        const hasSearchTerm = Boolean(searchTerm);

        clean.classList.toggle('show', hasSearchTerm);

        if (!hasSearchTerm) {
          showAllElements();
          return;
        }

        hideAllElements();
        filterLocations(searchTerm);
        filterProperties(searchTerm);
        updateEmptyState();
      }

      function clearSearch() {
        search.value = '';
        filterDestinations('');
      }

      let searchTimeout;
      search.addEventListener('input', (event) => {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(() => {
          const searchTerm = event.target.value.trim().toLowerCase();
          filterDestinations(searchTerm);
        }, 150);
      });

      if (clean) {
        clean.addEventListener('click', clearSearch);
      }
    });
  });
}
